import { forwardRef, useId, type InputHTMLAttributes } from 'react';
import clsx from 'clsx';
import styles from './Input.module.scss';

export interface NebiInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  fullWidth?: boolean;
}

export const Input = forwardRef<HTMLInputElement, NebiInputProps>(function Input(
  { label, error, helperText, fullWidth = true, className, id, ...rest },
  ref,
) {
  const autoId = useId();
  const inputId = id ?? `nebi-input-${autoId}`;
  const msgId = `${inputId}-msg`;
  const message = error ?? helperText;

  return (
    <div className={clsx(styles.wrapper, fullWidth && styles.fullWidth, className)}>
      {label && (
        <label className={styles.label} htmlFor={inputId}>
          {label}
        </label>
      )}
      <input
        ref={ref}
        id={inputId}
        className={clsx(styles.input, error && styles.invalid)}
        aria-invalid={error ? true : undefined}
        aria-describedby={message ? msgId : undefined}
        {...rest}
      />
      {message && (
        <span id={msgId} className={clsx(styles.message, error && styles.errorText)}>
          {message}
        </span>
      )}
    </div>
  );
});

export default Input;
